'use client';

import ModelLauncher from './ModelLauncher';

export default function ModelLauncherWrapper() {
  return <ModelLauncher />;
}